import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  DialogActions,
  Dialog,
  TextField,
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
} from "@mui/material";

import axiosInterceptorInstance from "../../../utils/axios.interceptor";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";

const OperatorName = () => {
  const agGridRef = useRef<AgGridReact | null>(null);
  const [simData, setSimData] = useState<any>([]);
  const [countryListN, setCountryListN] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [country, setCountry] = useState<any>("0");
  const [rowData, setRowData] = useState<any[]>([]);
  const [fullData, setFullData] = useState<any[]>([]);
  const [operator, setOperator] = useState<any>(0);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [perform, setPerform] = useState<boolean>(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [customOperatorName, setCustomOperatorName] = useState<string>("");

  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("user")) {
      var user = JSON.parse(localStorage.getItem("user") || "");
      if (user.Email == "tahir.shahzad@now.net.pk") {
        navigate("/fusionhub/operator-name");
      } else {
        navigate("/support/portin");
      }
    }
  }, []);

  const loadCountries = async () => {
    await fetch("/data/thacountry.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error " + response.status);
        }
        return response.json();
      })
      .then((json: any) => {
        setCountryListN(json.thacountries);
      });
  };
  const onGridReady = (params: { api: { sizeColumnsToFit: () => void } }) => {
    params.api.sizeColumnsToFit();
  };

  useEffect(() => {
    loadCountries();
    getOperator();
  }, []);

  useEffect(() => {
    const filterOperators = () => {
      const filteredData = fullData.filter((item: any) => {
        const matchesCountry =
          country !== "0" && country !== undefined
            ? item.country.countryIsoCode === country.isoCode2
            : true;

        return matchesCountry;
      });
      const filteredOperators = filteredData.map((item: any) => ({
        operator: item.operator,
        country: item.country,
      }));
      const sortedFilteredOperators = sortOperators(filteredOperators);

      setRowData(sortedFilteredOperators);
    };
    if (fullData.length > 0) {
      filterOperators();
    }
  }, [country]);

  const getProductData = () => {
    toast.dismiss();
    if (country !== "0" && country !== undefined) {
      getSimData();
    } else {
      toast.error("Please select the Country");
    }
  };
  const sortOperators = (operators: any[]) => {
    return operators.sort((a, b) =>
      a.operator?.operatorName.localeCompare(b.operator?.operatorName)
    );
  };
  const checkUpdation = () => {
    toast.dismiss();
    if (customOperatorName != "") {
      UpdateOperator();
    } else {
      toast.error("CustomName is required");
    }
  };
  const getOperator = async () => {
    toast.dismiss();
    await axiosInterceptorInstance
      .post(
        `/FusionHubCrm/GetOperators
`,
        {
          page: 1,
          recordsPerPage: 10000,
        }
      )
      .then((response: any) => {
        const responseData = response?.data.payload;

        const operators = responseData.map((item: any) => ({
          operator: item.operator,
          country: item.country,
        }));
        const sortedOperators = sortOperators(operators);
        setFullData(responseData);
        setRowData(sortedOperators);
        if (rowData.length == 0) {
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getSimData = async () => {
    setIsLoading(true);
    setSimData([]);

    await axiosInterceptorInstance
      .post(`/FusionHubCrm/GetOperatorMetaDetail`, {
        countryIsoCode: country.isoCode2,
        ...(operator?.operator?.operatorShortCode
          ? {
              operatorName: operator.operator.operatorName,
            }
          : {}),
      })
      .then((response: any) => {
        console.log(response);
        console.log(typeof response);

        const responseData = response.data;
        console.log(responseData);
        if (responseData.payload) {
          setSimData(responseData.payload);
        } else {
          toast.error(responseData.message);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const UpdateOperator = async () => {
    setPerform(true);
    await axiosInterceptorInstance
      .post(`FusionHubCrm/UpsertOperatorMetaDetail`, {
        Id: selectedRowData.id,
        OperatorName: selectedRowData.operatorName,
        CustomOperatorName: customOperatorName,
        SubcategoryShortCode: selectedRowData.subcategoryShortCode,
        CountryIsoCode: selectedRowData.countryIsoCode,
      })
      .then((res: any) => {
        const data = res.data;
        if (data.message?.toLowerCase().includes("successfully")) {
          setSimData((prevData: any) =>
            prevData.map((item: any) =>
              item.id === selectedRowData.id
                ? {
                    ...item,
                    customOperatorName: customOperatorName, // updated field
                  }
                : item
            )
          );
          toast.success(data.message);
        }

        setOpenDialog(false);
        setPerform(false);
      })
      .catch((error: any) => {
        setOpenDialog(false);
        setPerform(false);
      });
  };
  const columnDefs: ColDef[] = [
    {
      field: "id",
      headerName: "ID",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "operatorName",
      headerName: "OperatorName",
      filter: true,
      sortable: true,
      resizable: true,
    },

    {
      field: "customOperatorName",
      headerName: "CustomOperatorName",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "subcategoryShortCode",
      headerName: "SubcategoryShortCode",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "vendorName",
      headerName: "VendorName",
      filter: true,
      sortable: true,
      resizable: true,
    },
  ];

  const onRowClicked = (event: { data: any }) => {
    const rowData = event.data;
    setSelectedRowData(rowData);
    setCustomOperatorName(rowData.customOperatorName);
    setOpenDialog(true);
  };
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Operator Name</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <fieldset>
                <legend>General Information:</legend>

                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    {countryListN && (
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ background: "#fff", padding: " 0 5px" }}
                        >
                          Countries
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          className="formControl"
                          autoWidth
                          value={country?.isoCode2 || 0}
                          defaultValue={country?.isoCode2 || 0}
                          onChange={(e: any) => {
                            const country = countryListN?.find(
                              (item) => item.isoCode2 === e.target.value
                            );
                            setCountry(country);
                          }}
                        >
                          <MenuItem value="0">Select Country</MenuItem>
                          {countryListN.map((item, index) => (
                            <MenuItem key={index} value={item?.isoCode2}>
                              {item?.countryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </Grid>

                  <Grid item xs={6}>
                    <FormControl style={{ width: "100%" }}>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ background: "#fff", padding: " 0 5px" }}
                      >
                        Operator
                      </InputLabel>

                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="formControl"
                        autoWidth
                        value={operator?.operator?.operatorId || "0"}
                        defaultValue={operator?.operator?.operatorId || "0"}
                        onChange={(e: any) => {
                          const operator = rowData?.find(
                            (item: any) =>
                              item.operator?.operatorId === e.target.value
                          );

                          setOperator(operator);
                        }}
                      >
                        <MenuItem value="0">Choose Type</MenuItem>

                        {rowData.length > 0 ? (
                          rowData.map((item: any, index: any) => (
                            <MenuItem
                              key={index}
                              value={item.operator?.operatorId}
                            >
                              {item.country?.countryIsoCode}
                              {"-"}
                              {item.operator?.operatorName}
                            </MenuItem>
                          ))
                        ) : (
                          <div
                            className="circular-loader"
                            style={{ marginLeft: "0" }}
                          >
                            <CircularProgress size={40} />
                          </div>
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                {rowData.length == 0 && (
                  <div
                    className="circular-loader"
                    style={{ marginLeft: "0px" }}
                  >
                    <CircularProgress size={40} />
                  </div>
                )}
                {rowData.length > 0 && (
                  <Grid>
                    <Button
                      variant="contained"
                      onClick={getProductData}
                      sx={{
                        margin: "0 auto",
                        display: "block",
                        width: "280px !important",
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                )}
              </fieldset>
            </Grid>
          </Grid>
        </div>
      </div>
      {isLoading && (
        <div className="circular-loader" style={{ marginLeft: "0px" }}>
          <CircularProgress size={40} />
        </div>
      )}
      {simData?.length > 0 && (
        <div className="ag-theme-alpine">
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={12}
            pagination={true}
            domLayout="autoHeight"
            rowData={simData}
            columnDefs={columnDefs}
            onRowClicked={onRowClicked}
            onGridReady={onGridReady}
          ></AgGridReact>
        </div>
      )}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box style={{ padding: "0 16px " }}>
          <h1 className="heading" style={{ marginTop: "20px" }}>
            Updation Confirmation
          </h1>
          {selectedRowData && (
            <TableContainer
              component={Paper}
              style={{
                marginTop: "20px",
                marginBottom: "20px",
                padding: "0px",
              }}
            >
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <strong>ID</strong>
                    </TableCell>
                    <TableCell>{selectedRowData.id}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Operator Name</strong>
                    </TableCell>
                    <TableCell>{selectedRowData.operatorName}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Custom Operator Name</strong>
                    </TableCell>
                    <TableCell>{selectedRowData.customOperatorName}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Subcategory Short Code</strong>
                    </TableCell>
                    <TableCell>
                      {selectedRowData.subcategoryShortCode}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Vendor Name</strong>
                    </TableCell>
                    <TableCell>{selectedRowData.vendorName}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          )}

          <TextField
            className="formControl"
            style={{ marginTop: "20px" }}
            label="CustomName"
            variant="outlined"
            value={customOperatorName}
            onChange={(e) => setCustomOperatorName(e.target.value)}
          />

          <DialogActions>
            <Button
              variant="contained"
              className="dButton dButton2 dbuttonSec"
              onClick={() => setOpenDialog(false)}
            >
              No
            </Button>
            <div style={{ width: "30px" }}></div>
            {!perform && (
              <Button
                variant="contained"
                className="dButton dButton2"
                onClick={() => {
                  checkUpdation();
                }}
                autoFocus
              >
                Yes
              </Button>
            )}
            {perform && (
              <Button className="dButton dButton2" variant="contained">
                <CircularProgress color="inherit" size={30} />
              </Button>
            )}
          </DialogActions>
        </Box>
      </Dialog>
    </motion.div>
  );
};

export default OperatorName;
